__turbopack_context__.v({
  "container": "ProfileSwitcherOptions-module-scss-module__gs2zTa__container",
  "current": "ProfileSwitcherOptions-module-scss-module__gs2zTa__current",
  "label": "ProfileSwitcherOptions-module-scss-module__gs2zTa__label",
  "link": "ProfileSwitcherOptions-module-scss-module__gs2zTa__link",
  "links": "ProfileSwitcherOptions-module-scss-module__gs2zTa__links",
  "option": "ProfileSwitcherOptions-module-scss-module__gs2zTa__option",
  "optionHint": "ProfileSwitcherOptions-module-scss-module__gs2zTa__optionHint",
  "optionName": "ProfileSwitcherOptions-module-scss-module__gs2zTa__optionName",
  "optionText": "ProfileSwitcherOptions-module-scss-module__gs2zTa__optionText",
  "radio": "ProfileSwitcherOptions-module-scss-module__gs2zTa__radio",
});
